// extracted by mini-css-extract-plugin
export default {"card":"ExpSection_card__hO7wq","content":"ExpSection_content__aGpi3","card-image":"ExpSection_card-image__om8Ny","desc":"ExpSection_desc__W5-Gl"};